// This file is generated by pnpm icons:generate. Do not edit.

import {Newspaper2_Stroke2_Corner2_Rounded as CanonicalNewspaper2_Stroke2_Corner2_Rounded} from './Newspaper'

/** @deprecated Import Newspaper2_Stroke2_Corner2_Rounded from `#/components/icons/Newspaper` instead. */
export const Newspaper2_Stroke2_Corner2_Rounded =
  CanonicalNewspaper2_Stroke2_Corner2_Rounded
